import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { ImageComponent } from '@sp-client/app/components/image/image.component';
import { SidebarMenu } from '@sp-client/app/interfaces/sidebar.interface';
import { cm } from '@sp-shared';
import { BehaviorSubject } from 'rxjs';

import { LogService } from '../../services/log.service';
@Component({
	selector: 'sp-sidebar',
	imports: [CommonModule, RouterLink, RouterLinkActive, ImageComponent],
	templateUrl: './sidebar.component.html',
	styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
	readonly menu = input<SidebarMenu[]>();
	readonly isOpen = input<boolean>();
	private visible = new BehaviorSubject<boolean>(true);
	visibility$ = this.visible.asObservable();
	selection = output<string>();
	currentFragment: string = '';

	constructor(
		private route: ActivatedRoute,
		private log: LogService
	) {}

	ngOnInit(): void {
		this.route.fragment.subscribe(fragment => {
			this.currentFragment = fragment || '';
		});
	}

	isActive(fragment: string): boolean {
		return this.currentFragment === fragment;
	}

	getRouterLink(item: any): any {
		let routeLink = item.routeLink;
		routeLink = cm.isNotEmpty(routeLink) && routeLink.startsWith('/') ? routeLink.substring(1) : routeLink;
		return [{ outlets: { [item.outlet]: [routeLink] } }];
	}

	handleSelection(name: string) {
		this.log.debug('handle selection', name);
		this.selection.emit(name);
	}
}
